<template>
  <v-card class="mb-2 elevation-9">    
    <v-toolbar dark dense color="primary" height="25">
      <v-toolbar-title class="subheading">{{groupTitle}}</v-toolbar-title>
    </v-toolbar>
    <lineBitrate
      v-for="(n, index) in params"
      :key="`outBitrate` + index"
      :bitrateMax="n.max"
      :bitrateCurr="n.curr"
      :paramTitle="n.title"
    ></lineBitrate>
  </v-card>
</template>

<script>

import lineBitrate from "./lineBitrate";


export default {
  name: "outputBitrates",
  props: {
    groupTitle: {
      type: String,
      default: ""
    },
    params: {
      type: Array // [{title, curr, max}, .. ]
    }
  },
  components: {    
    lineBitrate
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

